import { useTranslation } from "react-i18next";
import { SpeedObject } from "../../Types/TableTypes";
import { getDistanceFromFt, getDistanceFromMt, getDistanceFromSq } from "../../Utils/Converters";


interface SpeedComponentProps{
    editMode: boolean,
    speed: SpeedObject,
    updateSpeed: (speed: SpeedObject)=>void
}

const SpeedComponent = (props: SpeedComponentProps)=> {
    const { t } = useTranslation();

    return (
        <div>
            {props.editMode ? 
                <div className='w-100 ps-3 pe-3'>
                    <div><b>{t("speed")}</b></div>
                    <div className="input-group mt-1 mb-1">
                        <span className="input-group-text col-2">{t("speed-walk")}</span>
                        <input 
                            value={props.speed.walk.mt}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"walk": getDistanceFromMt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">m</span>
                        <input 
                            value={props.speed.walk.ft}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"walk": getDistanceFromFt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">ft</span>
                        <input 
                            value={props.speed.walk.sq}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"walk": getDistanceFromSq(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">{t("sq")}</span>
                    </div>
                    <div className="input-group mt-1 mb-1">
                        <span className="input-group-text col-2">{t("speed-fly")}</span>
                        <input 
                            value={props.speed.fly.mt}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"fly": getDistanceFromMt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">m</span>
                        <input 
                            value={props.speed.fly.ft}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"fly": getDistanceFromFt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">ft</span>
                        <input 
                            value={props.speed.fly.sq}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"fly": getDistanceFromSq(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">{t("sq")}</span>
                    </div>
                    <div className="input-group mt-1 mb-1">
                        <span className="input-group-text col-2">{t("speed-swim")}</span>
                        <input 
                            value={props.speed.swim.mt}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"swim": getDistanceFromMt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">m</span>
                        <input 
                            value={props.speed.swim.ft}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"swim": getDistanceFromFt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">ft</span>
                        <input 
                            value={props.speed.swim.sq}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"swim": getDistanceFromSq(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">{t("sq")}</span>
                    </div>
                    <div className="input-group mt-1 mb-1">
                        <span className="input-group-text col-2">{t("speed-climb")}</span>
                        <input 
                            value={props.speed.climb.mt}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"climb": getDistanceFromMt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">m</span>
                        <input 
                            value={props.speed.climb.ft}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"climb": getDistanceFromFt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">ft</span>
                        <input 
                            value={props.speed.climb.sq}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"climb": getDistanceFromSq(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">{t("sq")}</span>
                    </div>
                    <div className="input-group mt-1 mb-1">
                        <span className="input-group-text col-2">{t("speed-burrow")}</span>
                        <input 
                            value={props.speed.burrow.mt}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"burrow": getDistanceFromMt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">m</span>
                        <input 
                            value={props.speed.burrow.ft}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"burrow": getDistanceFromFt(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">ft</span>
                        <input 
                            value={props.speed.burrow.sq}
                            type="number"
                            className="form-control text-center col-2"
                            onChange={e => {
                                let value = parseFloat(e.target.value);
                                let newSpeed = ({...props.speed,"burrow": getDistanceFromSq(value)});
                                props.updateSpeed(newSpeed);
                            }}
                        ></input>
                        <span className="input-group-text col-1">{t("sq")}</span>
                    </div>
                    <div className="input-group mt-1 mb-1">
                        <span className="input-group-text col-2">{t("speed-other")}</span>
                        <input 
                            value={props.speed.other}
                            type="text"
                            className="form-control text-center"
                            onChange={e => {
                                props.speed.other = e.target.value;
                                props.updateSpeed(props.speed);
                            }}
                        ></input>
                    </div>
                </div>
            :
                <div className='w-100 ps-3 pe-3'>
                    <span><b>{t("speed")}:</b></span>
                    &nbsp;
                    <span>
                        {props.speed.walk.mt+"m ("+props.speed.walk.sq+t("sq")+")"}
                        {props.speed.fly.mt>0? ", "+t("speed-fly")+" "+props.speed.fly.mt+"m ("+props.speed.fly.sq+t("sq")+")" : ""}
                        {props.speed.swim.mt>0? ", "+t("speed-swim")+" "+props.speed.swim.mt+"m ("+props.speed.swim.sq+t("sq")+")" : ""}
                        {props.speed.climb.mt>0? ", "+t("speed-climb")+" "+props.speed.climb.mt+"m ("+props.speed.climb.sq+t("sq")+")" : ""}
                        {props.speed.burrow.mt>0? ", "+t("speed-burrow")+" "+props.speed.burrow.mt+"m ("+props.speed.burrow.sq+t("sq")+")" : ""}
                        {props.speed.other? ", "+props.speed.other : ""}

                    </span>
                </div>
            }
        </div>
    );
}
export default SpeedComponent